export default "__VITE_ASSET__DoqXKk6u__"